import { connect } from 'react-redux';

import { SetBounced } from '../../weborder/actions/Actions';
import { routerActions } from '../../weborder/redux';
import { Bounce as BouncePage } from './Bounce';

export type DispatchProps = ReturnType<typeof mapDispatchToProps>;

const mapDispatchToProps = (dispatch: any) => ({
  SetBounced: (bounced: boolean) => {
    dispatch(SetBounced(bounced));
  },
  updateRouterState: (payload: WebOrder.State.Location) => {
    dispatch(routerActions.updateRouterState(payload));
  },
});

export const Bounce = connect(undefined, mapDispatchToProps)(BouncePage);
